import type { SVGIconsProps } from "../type";

export function EditIcon({ ...restProps }: SVGIconsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...restProps}
    >
      <path
        d="M15.2647 4.57614C15.6339 4.20723 16.1345 4 16.6564 4C17.1783 4 17.6788 4.20723 18.048 4.57614L19.2697 5.79789C19.6386 6.16706 19.8459 6.66761 19.8459 7.18952C19.8459 7.71142 19.6386 8.21197 19.2697 8.58114L9.58348 18.2674C9.34723 18.5036 9.05473 18.6769 8.73298 18.768L5.07561 19.8143C4.93084 19.8556 4.77765 19.8575 4.63191 19.8197C4.48618 19.7819 4.35321 19.7058 4.24681 19.5993C4.1404 19.4928 4.06444 19.3597 4.0268 19.214C3.98915 19.0682 3.9912 18.915 4.03273 18.7703L5.07786 15.114C5.16898 14.7923 5.34223 14.4986 5.57848 14.2613L15.2647 4.57502V4.57614ZM15.4627 10.002L13.8439 8.38202L6.77211 15.4549C6.73828 15.4887 6.71352 15.5305 6.70011 15.5764L6.07236 17.7735L8.26948 17.1458C8.31539 17.1324 8.35717 17.1076 8.39098 17.0738L15.4627 10.002ZM16.8555 5.76864C16.8294 5.74245 16.7983 5.72167 16.7642 5.70749C16.73 5.69331 16.6934 5.68601 16.6564 5.68601C16.6194 5.68601 16.5827 5.69331 16.5486 5.70749C16.5144 5.72167 16.4834 5.74245 16.4572 5.76864L15.0375 7.18952L16.6564 8.80952L18.0772 7.38864C18.1034 7.36252 18.1242 7.33148 18.1384 7.29731C18.1526 7.26314 18.1599 7.22651 18.1599 7.18952C18.1599 7.15252 18.1526 7.11589 18.1384 7.08172C18.1242 7.04755 18.1034 7.01652 18.0772 6.99039L16.8555 5.76864Z"
        fill="currentColor"
      />
    </svg>
  );
}
